/**
 * New Style Guide Color
 */

/** tosca */
const C_SECONDARY_TOSCA_1 = '#E5F7F8';
const C_SECONDARY_TOSCA_1_50 = 'rgba(229,247,248,0.5)';
const C_SECONDARY_TOSCA_2 = '#55F6FF';
const C_SECONDARY_TOSCA_3 = '#00B1BB';
const C_SECONDARY_TOSCA_4 = '#008188';
const C_SECONDARY_TOSCA_5 = '#005155';

/** red */
const C_SECONDARY_RED_1 = '#FFEFEE';
const C_SECONDARY_RED_2 = '#FF8E88';
const C_SECONDARY_RED_3 = '#FF5E55';
const C_SECONDARY_RED_4 = '#EE0D00';
const C_SECONDARY_RED_5 = '#880700';

/** green */
const C_TERTIARY_GREEN_1 = '#EFFFFB';
const C_TERTIARY_GREEN_2 = '#03A87C';

/** yellow */
const C_TERTIARY_YELLOW_1 = '#FDF9E1';
const C_TERTIARY_YELLOW_2 = '#EFD634';
const C_TERTIARY_YELLOW_3 = '#F9C21D';

/** brown */
const C_TERTIARY_BROWN_1 = '#F1EEE8';
const C_TERTIARY_BROWN_2 = '#5E5038';

/** purple  */
const C_TERTIARY_PURPLE_1 = '#EEEEF7';
const C_TERTIARY_PURPLE_2 = '#3A397A';

/** black */
const C_BLACK_5 = '#F2F4F4';
const C_BLACK_10 = '#E5E8E8';
const C_BLACK_15 = '#D9DEDE';
const C_BLACK_20 = '#CCD2D3';
const C_BLACK_25 = '#BFC7C8';
const C_BLACK_30 = '#B2BCBC';
const C_BLACK_35 = '#A6B1B2';
const C_BLACK_40 = '#99A6A7';
const C_BLACK_45 = '#8C9A9B';
const C_BLACK_50 = '#7F8F90';
const C_BLACK_55 = '#738586';
const C_BLACK_60 = '#66797A';
const C_BLACK_65 = '#596E6F';
const C_BLACK_70 = '#4C6264';
const C_BLACK_75 = '#40585A';
const C_BLACK_80 = '#334D4E';
const C_BLACK_85 = '#264143';
const C_BLACK_90 = '#193638';
const C_BLACK_95 = '#0D2B2D';
const C_BLACK_100 = '#002022';

/** grey */
const C_GREY_100 = '#F0F0EE';

/** white */
const C_WHITE_100 = '#FFFFFF';

/** blue */
const C_BLUE_FACEBOOK = 'rgb(59, 89, 152)';

/** transparent */
const C_TRANSPARENT = 'rgba(0,0,0,0)';

/* V2 colors */
const C_TEAL_100 = '#E6F7F8';
const C_TEAL_500 = '#01ADB7';
const C_YELLOW_100 = '#FEF7E8';
const C_YELLOW_500 = '#F4AB1C';
const C_RED_100 = '#FDECEB';
const C_RED_500 = '#EF4237';
const C_RED_800 = '#6F223A';
const C_PINK_500 = '#FFB9AB';
const C_ORANGE_500 = '#F95C06';
const C_BROWN_300 = '#E3D9CD';
const C_BROWN_500 = '#514A42';
const C_GREEN_500 = '#7DAB6B';
const C_NEUTRAL_0 = '#FFFFFF';
const C_NEUTRAL_10 = '#F7F8F8';
const C_NEUTRAL_20 = '#F5F6F6';
const C_NEUTRAL_30 = '#EBEDEE';
const C_NEUTRAL_40 = '#E5E8E9';
const C_NEUTRAL_50 = '#BFC8C9';
const C_NEUTRAL_60 = '#B0BBBB';
const C_NEUTRAL_70 = '#A3B0B1';
const C_NEUTRAL_80 = '#94A3A3';
const C_NEUTRAL_90 = '#859596';
const C_NEUTRAL_100 = '#758889';
const C_NEUTRAL_200 = '#667B7C';
const C_NEUTRAL_300 = '#576E6F';
const C_NEUTRAL_400 = '#4A6364';
const C_NEUTRAL_500 = '#3B5657';
const C_NEUTRAL_600 = '#2E4B4C';
const C_NEUTRAL_700 = '#1C3B3D';
const C_NEUTRAL_800 = '#0D2E30';
const C_NEUTRAL_900 = '#002325';

/** backward compatibility */
const RGBByColor = {
  black: '0, 32, 34',
  white: '255, 255, 255'
};
const generateRGBA = (color, alpha) => `rgba(${RGBByColor[color]}, ${alpha})`;
const colors = {
  /** primary */
  C_PRIMARY_TOSCA: C_SECONDARY_TOSCA_4,
  C_PRIMARY_RED: C_SECONDARY_RED_3,
  /** tosca */
  C_SECONDARY_TOSCA_1,
  C_SECONDARY_TOSCA_1_50,
  C_SECONDARY_TOSCA_2,
  C_SECONDARY_TOSCA_3,
  C_SECONDARY_TOSCA_4,
  C_SECONDARY_TOSCA_5,
  /** red */
  C_SECONDARY_RED_1,
  C_SECONDARY_RED_2,
  C_SECONDARY_RED_3,
  C_SECONDARY_RED_4,
  C_SECONDARY_RED_5,
  /** green */
  C_TERTIARY_GREEN_1,
  C_TERTIARY_GREEN_2,
  /** yellow */
  C_TERTIARY_YELLOW_1,
  C_TERTIARY_YELLOW_2,
  C_TERTIARY_YELLOW_3,
  /** brown */
  C_TERTIARY_BROWN_1,
  C_TERTIARY_BROWN_2,
  /** purple */
  C_TERTIARY_PURPLE_1,
  C_TERTIARY_PURPLE_2,
  /** black */
  C_BLACK_5,
  C_BLACK_10,
  C_BLACK_15,
  C_BLACK_20,
  C_BLACK_25,
  C_BLACK_30,
  C_BLACK_35,
  C_BLACK_40,
  C_BLACK_45,
  C_BLACK_50,
  C_BLACK_55,
  C_BLACK_60,
  C_BLACK_65,
  C_BLACK_70,
  C_BLACK_75,
  C_BLACK_80,
  C_BLACK_85,
  C_BLACK_90,
  C_BLACK_95,
  C_BLACK_100,
  /** grey */
  C_GREY_100,
  /** white */
  C_WHITE_100,
  /** blue */
  C_BLUE_FACEBOOK,
  /** transparent */
  C_TRANSPARENT,
  /** v2 colors */
  C_TEAL_100,
  C_TEAL_500,
  C_YELLOW_100,
  C_YELLOW_500,
  C_RED_100,
  C_RED_500,
  C_RED_800,
  C_PINK_500,
  C_ORANGE_500,
  C_BROWN_300,
  C_BROWN_500,
  C_GREEN_500,
  C_NEUTRAL_0,
  C_NEUTRAL_10,
  C_NEUTRAL_20,
  C_NEUTRAL_30,
  C_NEUTRAL_40,
  C_NEUTRAL_50,
  C_NEUTRAL_60,
  C_NEUTRAL_70,
  C_NEUTRAL_80,
  C_NEUTRAL_90,
  C_NEUTRAL_100,
  C_NEUTRAL_200,
  C_NEUTRAL_300,
  C_NEUTRAL_400,
  C_NEUTRAL_500,
  C_NEUTRAL_600,
  C_NEUTRAL_700,
  C_NEUTRAL_800,
  C_NEUTRAL_900,
  generateRGBA
};
export default colors;